import { useAuth } from "../contexts/auth";
const AuthorisedFor = ({ action, yes, no }) => {
  const auth = useAuth();
  return auth.isAuthorised(action) ? yes : no;
};

export default AuthorisedFor;
